import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import { RootState } from '../../redux/rootReducers';
import { ClientType } from '../../redux/auth/authTypes';
import {
  assignColumnsToClientAction,
  getIndividualClientColumnAction,
  resetInvoiceStatusCode,
  getAllColumnsAction,
  resetInvoicingError,
  resetInvoicingSuccess
} from '../../redux/invoicing';
import './AssignColumns.scss';
import { InvoiceColumnsType } from '../../redux/invoicing/invoicingTypes';
import { AssignColumnType, GetClientColumnPayload } from '../../commonTypes/invoicingTypes';
import {
  ErrorSuccessModal,
  CommonHeader,
  Loader,
  DropDown
} from '../../components/commons';
import { getAllClientsAction, resetSession } from '../../redux/auth';
import Select from 'react-select';
import useDebounce from '../../customHooks/useDebounce';
import { getClientDirectoryListAction } from '../../redux/clientDirectory';

type getAllClientPayload={
  token:string;
  offset:number;
  limit:number;
  searchValue:string | undefined;
}

type AppProps = {
  clientList: ClientType[] | [];
  fetching: boolean;
  invoiceFetching: boolean;
  token: string | null;
  error: string | null;
  invoiceError: string | null;
  statusCode: number | null;
  success: null | number;
  totalClientsCount:any;
  invoiceColumnList: InvoiceColumnsType;
  individualColumnList: InvoiceColumnsType;
  dispatchGetAllColumnsAction: (token: string) => void;
  dispatchAssignColumnsToClientAction: (data: AssignColumnType) => void;
  dispatchGetClientColumnListAction: (data: GetClientColumnPayload) => void;
  dispatchResetSession: () => void;
  dispatchResetInvoiceStatusCode: () => void;
  dispatchResetInvoicingError: () => void;
  dispatchResetInvoicingSuccess: () => void;
  dispatchGetAllClientAction:(data:getAllClientPayload)=>void;
};

type columnType = {
  id?: number;
  column_name?: string | undefined;
  data_type?: string | undefined;
  name?: string | undefined;
  type?: string | undefined;
}

type clientListType = {
  value: number | undefined;
  label: string | undefined;
}

const AssignColumns = ({
  clientList,
  token,
  success,
  dispatchGetAllColumnsAction,
  dispatchAssignColumnsToClientAction,
  dispatchGetClientColumnListAction,
  dispatchResetInvoiceStatusCode,
  dispatchResetSession,
  dispatchGetAllClientAction,
  dispatchResetInvoicingSuccess,
  dispatchResetInvoicingError,
  invoiceColumnList,
  individualColumnList,
  fetching,
  invoiceFetching,
  error,
  invoiceError,
  statusCode,
  totalClientsCount
}: AppProps) => {
  const [clientId, setClientId] = useState<any>(null);
  const [finalClientList, setFinalClientList] = useState<clientListType[]>([]);
  const [expenseList, setExpenseList] = useState<number[] | []>([]);
  const [revenueList, setRevenueList] = useState<number[] | []>([]);
  const [otherList, setOtherList] = useState<number[] | []>([]);
  const [finalExpensesList, setFinalExpensesList] = useState<any>([]);
  const [finalRevenueList, setFinalRevenueList] = useState<any>([]);
  const [finalOthersList, setFinalOthersList] = useState<any>([]);
  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: 'Select Client...'
  });
  const [limit, setLimit] = useState(20);
  const [offset, setoffset] = useState(0);
  const [text, setText] = useState<string>("");
  const[loadCondition,setLoadCondition]= useState(true)

  // Fetching all the columns list and adding type
  useEffect(() => {
    const { expenses, revenue, others } = invoiceColumnList;
    // Adding type to expenses column
    let finalExpenses: any[] = [];
    expenses?.map((expense: any) => {
      finalExpenses.push({
        ...expense,
        type: 'expense'
      })
    });
    setFinalExpensesList(finalExpenses);

    // Adding type to revenue column
    let finalRevenue: any[] = [];
    revenue?.map((revenueData: any) => {
      finalRevenue.push({
        ...revenueData,
        type: 'revenue'
      })
    });
    setFinalRevenueList(finalRevenue);

    // Adding type to others column
    let finalOthers: any[] = [];
    others?.map((other: any) => {
      finalOthers.push({
        ...other,
        type: 'others'
      })
    });
    setFinalOthersList(finalOthers);
  }, [invoiceColumnList]);


  useEffect(() => {
    if (token) {
      if (offset <= +totalClientsCount) { 
        let finalClientData = {
          token,
          offset,
          limit,
          searchValue: text,
          status:1
        };
        dispatchGetAllClientAction(finalClientData);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    if(token){
      const finalData = {
        token,
        offset,
        limit,
        searchValue: text,
         status:1
       }
       dispatchGetAllClientAction(finalData)  
    }
  }

  

  useDebounce(() => {
    fetchNewData(text)
}, 500, [text])

  useEffect(() => {
    if (clientList?.length > 0) {
      if (offset <= +totalClientsCount) {
        let finalClientData = clientList?.map((user: any) => {
          return {
            value: user.client_code,
            label: `(${user.client_code}) ${user.company_name}`,
          };
        });

        if (offset>0) {
          setFinalClientList([...finalClientList, ...finalClientData]);
        } else {
          setFinalClientList([...finalClientData]);
        }
      }
    }
  }, [clientList]);
 
  // Fetching already assigned columns to the client
  useEffect(() => {
    let finalOldExpenseList: any[] = [];
    let finalOldRevenueList: any[] = [];
    let finalOldOthersList: any[] = [];

    const { expenses, revenue, others } = individualColumnList;

    expenses?.map((expense: any) => finalOldExpenseList.push(expense?.column_id));
    revenue?.map((rev: any) => finalOldRevenueList.push(rev?.column_id));
    others?.map((other: any) => finalOldOthersList.push(other?.column_id));

    setRevenueList(finalOldRevenueList);
    setExpenseList(finalOldExpenseList);
    setOtherList(finalOldOthersList);

  }, [individualColumnList]);


  useEffect(() => {
    if (token) {
      dispatchGetAllColumnsAction(token);
    }
    dispatchResetInvoicingError();
    dispatchResetInvoicingSuccess();
    handleResetData();
  }, []);

  const handleGetInvidualClientColumns = (client: number | null) => {
    if (client && token) {
      let finalData = {
        client_code: client,
        token
      }

      dispatchGetClientColumnListAction(finalData);
    }
  }

  const handleChangeClient = (client: any) => {
    setClientId(client.value);
    setClientSelected(client)
    if (client) {
      handleGetInvidualClientColumns(client.value);
    }
  }

  const handleAddColumn = (id: number | undefined, type: string | undefined) => {
    let prevRevenueList = [...revenueList];
    let prevExpenseList = [...expenseList];
    let prevOthersList = [...otherList];

    let newRevenueColumn: any[] = [];
    let newExpenseColumn: any[] = [];
    let newOtherColumn: any[] = [];

    if (type === 'expense') {
      let oldId = prevExpenseList.find(arrId => arrId === id);
      if (oldId) {
        newExpenseColumn = prevExpenseList.filter(arrId => arrId !== id);
      } else {
        newExpenseColumn = [...prevExpenseList, id];
      }
      setExpenseList(newExpenseColumn);
    } else if (type === 'revenue') {
      let oldId = prevRevenueList.find(arrId => arrId === id);
      if (oldId) {
        newRevenueColumn = prevRevenueList.filter(arrId => arrId !== id);
      } else {
        newRevenueColumn = [...prevRevenueList, id];
      }
      setRevenueList(newRevenueColumn);
    } else if (type === 'others') {
      let oldId = prevOthersList.find(arrId => arrId === id);
      if (oldId) {
        newOtherColumn = prevOthersList.filter(arrId => arrId !== id);
      } else {
        newOtherColumn = [...prevOthersList, id];
      }
      setOtherList(newOtherColumn);
    }
  }

  const handleAssignColumns = () => {
    if (clientId && token) {
      let finalData = {
        client_code: clientId,
        expenses: expenseList,
        revenues: revenueList,
        others: otherList,
        token
      }

      dispatchAssignColumnsToClientAction(finalData);
    }
  }

  const handleResetData = () => {
    setRevenueList([]);
    setExpenseList([]);
    setClientId(null);
    setClientSelected({
      value: null,
      label: 'Select Client...'
    });
  }

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setoffset((prv) => prv + limit);
  };
  const onMenuClose = () => setLoadCondition(true);

  const handleCallResetSessionFunctions = () => {
    dispatchResetInvoiceStatusCode();
    dispatchResetSession();
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!invoiceError}
            title="Error"
            message={"Session Expired! Login Again."}
            buttonText="Logout"
            onPress={() => handleCallResetSessionFunctions()}
            statusCode={statusCode}
          />
        )
      } else if ((!!error || !!invoiceError && statusCode !== 401)) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!invoiceError}
            title="Error"
            message={error || invoiceError}
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoicingError();
              // handleResetData();
            }}
          />
        )
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Columns Assigned To Clients Successfully!"
          buttonText="OK"
          onPress={() => {
            handleResetData();
            dispatchResetInvoicingSuccess();
          }}
          statusCode={statusCode}
        />
      )
    }

    return false;
  }

  const renderExpenseColumnList = () => {
    let finalColumnList = finalExpensesList.map((column: columnType) => {
      let assignedId = expenseList.find(oldId => oldId === column?.id);

      return (
        <li key={column.id}>
          <Input
            type="checkbox"
            onChange={() => handleAddColumn(column.id, column.type)}
            checked={!!assignedId}
          />
          {column.name}
        </li>
      )
    });

    return finalColumnList;
  }

  const renderRevenueColumnList = () => {
    let finalColumnList = finalRevenueList.map((column: columnType) => {
      let assignedId = revenueList.find(oldId => oldId === column?.id)
      return (
        <li key={column.id}>
          <Input
            type="checkbox"
            onChange={() => handleAddColumn(column.id, column.type)}
            checked={!!assignedId}
          />
          {column.name}
        </li>
      )
    });

    return finalColumnList;
  }

  const renderOthersColumnList = () => {
    let finalColumnList = finalOthersList.map((column: columnType) => {
      let assignedId = otherList.find(oldId => oldId === column?.id)
      return (
        <li key={column.id}>
          <Input
            type="checkbox"
            onChange={() => handleAddColumn(column.id, column.type)}
            checked={!!assignedId}
          />
          {column.name}
        </li>
      )
    });

    return finalColumnList;
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <CommonHeader title="Assign Columns to Clients" />
      </div>
      <div className="col-md-4 mt-3">
        <h3 className="mb-3">Choose Client</h3>
        <Select
          options={finalClientList}
          value={clientSelected}
          cacheOptions
          onChange={handleChangeClient}
          onMenuScrollToBottom={(e: any) => checkBottom(e)}
          onInputChange={(e: string) => {
            setLoadCondition(false);
            setText(e);
            setoffset(0);
          }}
          onMenuClose={onMenuClose}
          isLoading={!loadCondition&&fetching}
        />
      </div>
      <div className="col-md-8 mt-3">
        <h3>Choose Column</h3>
        <div className="">
          {clientId ?
            <div className="column-container">
              <div className="">
                <h4>Expenses Columns</h4>
                <ul className="column-list">
                  {renderExpenseColumnList()}
                </ul>
              </div>
              <div className="">
                <h4>Revenue Columns</h4>
                <ul className="column-list">
                  {renderRevenueColumnList()}
                </ul>
              </div>
              <div className="">
                <h4>Other Columns</h4>
                <ul className="column-list">
                  {renderOthersColumnList()}
                </ul>
              </div>
            </div> :
            <div className="column-container">
              <p className="text-center mt-3">Please Choose A Client...</p>
            </div>}
        </div>
        <button
          className="btn btn-primary mt-4 pointer"
          onClick={handleAssignColumns}
          style={{ width: '50%' }}
          disabled={!clientId}
        >
          Assign Columns
        </button>
      </div>
      {(invoiceFetching && loadCondition) || (fetching && loadCondition) ? <Loader /> : null}
      {handleErrorModal()}
    </div>
  )
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  clientList: state.clientDirectory.clientDirectoryList,
  totalClientsCount:state.clientDirectory.totalCount,
  fetching: state.clientDirectory.fetching,
  invoiceFetching: state.invoicing.fetching,
  error: state.clientDirectory.error,
  invoiceError: state.invoicing.error,
  success: state.invoicing.success,
  invoiceColumnList: state.invoicing.columnList,
  statusCode: state.invoicing.statusCode,
  individualColumnList: state.invoicing.individualColumnList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllColumnsAction: (token: string) => dispatch(getAllColumnsAction(token)),
  dispatchGetAllClientAction:(data:getAllClientPayload)=>
  dispatch(getClientDirectoryListAction(data)),
  dispatchAssignColumnsToClientAction: (data: AssignColumnType) =>
    dispatch(assignColumnsToClientAction(data)),
  dispatchGetClientColumnListAction: (data: GetClientColumnPayload) =>
    dispatch(getIndividualClientColumnAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetInvoiceStatusCode: () => dispatch(resetInvoiceStatusCode()),
  dispatchResetInvoicingError: () => dispatch(resetInvoicingError()),
  dispatchResetInvoicingSuccess: () => dispatch(resetInvoicingSuccess())
})

export default connect(mapStateToProps, mapDispatchToProps)(AssignColumns);
